export default {
  REVIEWS_FETCHED(state, reviews) {
    state.reviews = reviews
    state.loading = false
  },
  SET_LOADING(state, loading) {
    state.loading = loading
  }
}
